(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    // Discount codes: /cart/update.js has accepted a "discount" param since
    // Shopify's May 2025 Cart AJAX API update, writing straight to the real
    // cart - it carries through checkout automatically (including Shop Pay/
    // Apple Pay express buttons, unlike the old ?discount= URL param trick).
    // Invalid/expired codes still return 200 with the cart unchanged, so
    // success has to be judged by whether cart_level_discount_applications
    // actually grew, not by the response status.
    const discountInput = document.getElementById('CartDiscountCode');
    const applyBtn = document.getElementById('CartDiscountApplyBtn');
    // /cart/update.js's discount param only affects the storefront cart's own
    // price preview - it does NOT carry into checkout creation (confirmed by
    // testing: checkout loaded with the discount code box empty and full
    // price). The only reliable way to carry it through is the checkout
    // ?discount= URL param, so track the currently-applied code and pass it
    // along explicitly when "Proceed to Checkout" is clicked.
    let appliedDiscountCode = discountInput ? discountInput.value.trim() : '';
    const messageEl = document.getElementById('CartDiscountMessage');
    const discountRow = document.getElementById('CartDiscountRow');
    const discountLabel = document.getElementById('CartDiscountLabel');
    const discountAmountEl = document.getElementById('CartDiscountAmount');
    const subtotalEl = document.getElementById('CartSubtotal');
    const taxRow = document.getElementById('CartTaxRow');
    const taxAmountEl = document.getElementById('CartTaxAmount');
    const taxNoteEl = document.getElementById('CartTaxNote');
    const grandTotalEl = document.getElementById('CartGrandTotal');

    const formatMoney = (cents) => '₹ ' + (cents / 100).toLocaleString('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });

    const showMessage = (text, isError) => {
      if (!messageEl) return;
      messageEl.textContent = text;
      messageEl.classList.toggle('is-error', !!isError);
      messageEl.hidden = !text;
    };

    const applyCartUpdate = (cart) => {
      // Shopify omits total_tax/total_discount from the response entirely
      // (not just 0) when there's nothing to report yet, e.g. tax with no
      // shipping address on file - coerce so the math below can't go NaN.
      const totalTax = cart.total_tax || 0;
      const totalDiscount = cart.total_discount || 0;

      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.original_total_price);

      if (totalDiscount > 0) {
        if (discountRow) discountRow.hidden = false;
        if (discountAmountEl) discountAmountEl.textContent = formatMoney(totalDiscount);
        if (discountLabel) {
          const titles = (cart.cart_level_discount_applications || []).map((d) => d.title).join(', ');
          discountLabel.textContent = 'Discount' + (titles ? ` (${titles})` : '');
        }
        if (applyBtn) applyBtn.textContent = 'Remove';
      } else {
        if (discountRow) discountRow.hidden = true;
        if (applyBtn) applyBtn.textContent = 'Apply';
      }

      if (taxRow) taxRow.hidden = totalTax === 0;
      if (taxAmountEl) taxAmountEl.textContent = formatMoney(totalTax);
      if (taxNoteEl) {
        taxNoteEl.textContent = totalTax > 0
          ? 'Includes all taxes. Free Shipping on all orders.'
          : 'Tax calculated at checkout. Free Shipping on all orders.';
      }

      const grandTotal = cart.taxes_included ? cart.total_price : cart.total_price + totalTax;
      if (grandTotalEl) grandTotalEl.textContent = formatMoney(grandTotal);
    };

    if (applyBtn && discountInput) {
      applyBtn.addEventListener('click', () => {
        const isRemoving = applyBtn.textContent.trim() === 'Remove';
        const code = isRemoving ? '' : discountInput.value.trim();

        if (!isRemoving && !code) {
          showMessage('Enter a code to apply.', true);
          return;
        }

        const previousDiscountCount = discountRow && !discountRow.hidden ? 1 : 0;
        applyBtn.disabled = true;
        showMessage('', false);

        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: code })
        })
          .then((res) => res.json())
          .then((cart) => {
            const newDiscountCount = (cart.cart_level_discount_applications || []).length;
            applyCartUpdate(cart);

            if (isRemoving) {
              discountInput.value = '';
              appliedDiscountCode = '';
              showMessage('Discount removed.', false);
            } else if (newDiscountCount > previousDiscountCount || cart.total_discount > 0) {
              appliedDiscountCode = code;
              showMessage('Discount applied.', false);
            } else {
              appliedDiscountCode = '';
              showMessage('That code is invalid or expired.', true);
            }
          })
          .catch(() => {
            showMessage('Could not apply that code. Please try again.', true);
          })
          .finally(() => {
            applyBtn.disabled = false;
          });
      });
    }

    const checkoutBtn = document.getElementById('CartCheckoutBtn');
    const noteInput = document.getElementById('CartNote');
    if (checkoutBtn) {
      checkoutBtn.addEventListener('click', (e) => {
        if (!appliedDiscountCode) return; // no discount active - let the form submit normally

        e.preventDefault();
        const rootUrl = checkoutBtn.dataset.rootUrl || '/';
        const goToCheckout = () => {
          window.location.href = `${rootUrl}checkout?discount=${encodeURIComponent(appliedDiscountCode)}`;
        };
        // This bypasses the normal form submit (needed to carry the discount
        // code through), so the gift note has to be saved separately here -
        // otherwise it's silently dropped instead of reaching the order.
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ note: noteInput ? noteInput.value : '' })
        }).then(goToCheckout).catch(goToCheckout);
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const form = document.querySelector('#CollectionFiltersForm');
    if (!form) return;

    // Form Submission helper
    const submitForm = () => {
      // Create new URL query search parameters from form values
      const formData = new FormData(form);
      const searchParams = new URLSearchParams(window.location.search);
      
      // Clear existing filter params (e.g. filter.p.price, filter.v.option)
      const keysToClear = [];
      for (const key of searchParams.keys()) {
        if (key.startsWith('filter.')) {
          keysToClear.push(key);
        }
      }
      keysToClear.forEach(key => searchParams.delete(key));

      // Append active params from form
      for (const [key, value] of formData.entries()) {
        if (key.startsWith('filter.') && value !== '') {
          searchParams.append(key, value);
        }
      }
      
      // Update location
      window.location.href = window.location.pathname + '?' + searchParams.toString();
    };

    // Synchronize inputs between desktop and mobile versions
    const syncInputs = (e) => {
      const input = e.target;
      const name = input.name;
      const type = input.type;
      
      // Only sync if there's a mobile sibling
      let mobileName = name;
      let destSelector = '';
      
      if (name.includes('mobile')) {
        // Mobile input changed -> update desktop
        const cleanName = name.replace('_mobile', '');
        destSelector = `input[name="${cleanName}"]`;
      } else {
        // Desktop input changed -> update mobile
        const mobileName = name + '_mobile';
        destSelector = `input[name="${mobileName}"]`;
      }
      
      const sibs = form.querySelectorAll(destSelector);
      sibs.forEach(sib => {
        if (type === 'checkbox') {
          sib.checked = input.checked;
        } else {
          sib.value = input.value;
        }
      });
      
      // Trigger update on sliders
      const sliderWrapper = input.closest('.price-range-slider-wrapper');
      if (sliderWrapper) {
        // Find sibling slider wrapper
        const otherWrappers = form.querySelectorAll('.price-range-slider-wrapper');
        otherWrappers.forEach(w => {
          if (w !== sliderWrapper) {
            const wRangeMin = w.querySelector('.range-min');
            const wRangeMax = w.querySelector('.range-max');
            const wInputMin = w.querySelector('.input-min');
            const wInputMax = w.querySelector('.input-max');
            
            if (input.classList.contains('input-min') || input.classList.contains('range-min')) {
              wRangeMin.value = input.value;
              wInputMin.value = input.value;
            } else {
              wRangeMax.value = input.value;
              wInputMax.value = input.value;
            }
            // Trigger visual update
            wRangeMin.dispatchEvent(new Event('input'));
          }
        });
      }

      // If mobile drawer is not open, submit immediately
      const isMobileDrawerOpen = document.querySelector('.mobile-filter-drawer').classList.contains('is-open');
      if (!isMobileDrawerOpen && type !== 'number') {
        submitForm();
      }
    };

    form.addEventListener('change', (e) => {
      if (e.target.name === 'sort_by') {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', e.target.value);
        window.location.href = url.toString();
      } else if (e.target.name === 'sort_by_mobile') {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', e.target.value);
        window.location.href = url.toString();
      } else {
        syncInputs(e);
      }
    });

    // Initialize Price Sliders
    const sliders = form.querySelectorAll('.price-range-slider-wrapper');
    sliders.forEach(container => {
      const rangeMin = container.querySelector('.range-min');
      const rangeMax = container.querySelector('.range-max');
      const inputMin = container.querySelector('.input-min');
      const inputMax = container.querySelector('.input-max');
      const fill = container.querySelector('.range-slider-fill');
      
      if (!rangeMin || !rangeMax) return;
      
      const minVal = parseFloat(container.getAttribute('data-min'));
      const maxVal = parseFloat(container.getAttribute('data-max'));
      const span = maxVal - minVal || 1;
      
      const updateSlider = () => {
        let min = parseFloat(rangeMin.value);
        let max = parseFloat(rangeMax.value);
        
        if (min > max) {
          const temp = min;
          min = max;
          max = temp;
        }
        
        const pctMin = ((min - minVal) / span) * 100;
        const pctMax = ((max - minVal) / span) * 100;
        
        fill.style.left = pctMin + '%';
        fill.style.right = (100 - pctMax) + '%';
        
        inputMin.value = Math.round(min);
        inputMax.value = Math.round(max);
      };
      
      updateSlider();

      rangeMin.addEventListener('input', updateSlider);
      rangeMax.addEventListener('input', updateSlider);
      
      // Handle keyups / inputs release
      rangeMin.addEventListener('change', () => {
        const isMobileDrawerOpen = document.querySelector('.mobile-filter-drawer').classList.contains('is-open');
        if (!isMobileDrawerOpen) submitForm();
      });
      rangeMax.addEventListener('change', () => {
        const isMobileDrawerOpen = document.querySelector('.mobile-filter-drawer').classList.contains('is-open');
        if (!isMobileDrawerOpen) submitForm();
      });
    });

    // Mobile Drawer Open/Close triggers
    const drawer = document.querySelector('.mobile-filter-drawer');
    const drawerTitle = document.querySelector('#MobileDrawerTitle');
    const openBtns = document.querySelectorAll('[data-open-drawer]');
    const closeBtns = document.querySelectorAll('[data-close-drawer]');

    if (drawer) {
      openBtns.forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          drawer.classList.add('is-open');
          document.body.style.overflow = 'hidden';

          const mode = btn.getAttribute('data-open-drawer');
          if (mode === 'sort') {
            if (drawerTitle) drawerTitle.textContent = 'Sort By';
            const sortField = drawer.querySelector('#SortByMobile');
            if (sortField) sortField.scrollIntoView({ block: 'start' });
          } else if (drawerTitle) {
            drawerTitle.textContent = 'Filters';
          }
        });
      });
      
      closeBtns.forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          drawer.classList.remove('is-open');
          document.body.style.overflow = '';
        });
      });

      // Handle mobile drawer form submission specifically
      form.addEventListener('submit', (e) => {
        const isMobileDrawerOpen = drawer.classList.contains('is-open');
        if (isMobileDrawerOpen) {
          e.preventDefault();
          
          // Clear mobile tags from final submit payload
          const formData = new FormData(form);
          const searchParams = new URLSearchParams(window.location.search);
          
          // Remove old filters
          const keysToClear = [];
          for (const key of searchParams.keys()) {
            if (key.startsWith('filter.')) {
              keysToClear.push(key);
            }
          }
          keysToClear.forEach(key => searchParams.delete(key));

          // Load from mobile form
          for (const [key, value] of formData.entries()) {
            // Mobile parameters might end with _mobile or have mobile in name
            if (key.startsWith('filter.') && value !== '') {
              const cleanKey = key.replace('_mobile', '');
              searchParams.append(cleanKey, value);
            }
          }
          
          // Apply sorting if changed on mobile
          const mobileSort = form.querySelector('#SortByMobile');
          if (mobileSort) {
            searchParams.set('sort_by', mobileSort.value);
          }
          
          window.location.href = window.location.pathname + '?' + searchParams.toString();
        }
      });
    }

    // Grid columns switcher logic (Desktop)
    const gridSwitch3 = document.querySelector('.grid-switch-3');
    const gridSwitch5 = document.querySelector('.grid-switch-5');
    const productGrid = document.querySelector('.product-grid');

    if (gridSwitch3 && gridSwitch5 && productGrid) {
      const setCols = (cols) => {
        if (cols === 5) {
          productGrid.classList.add('grid-cols-5');
          productGrid.classList.remove('grid-cols-3');
          gridSwitch5.classList.add('is-active');
          gridSwitch3.classList.remove('is-active');
          localStorage.setItem('collection-cols', '5');
        } else {
          productGrid.classList.add('grid-cols-3');
          productGrid.classList.remove('grid-cols-5');
          gridSwitch3.classList.add('is-active');
          gridSwitch5.classList.remove('is-active');
          localStorage.setItem('collection-cols', '3');
        }
      };

      gridSwitch3.addEventListener('click', (e) => {
        e.preventDefault();
        setCols(3);
      });
      gridSwitch5.addEventListener('click', (e) => {
        e.preventDefault();
        setCols(5);
      });

      // Restore state
      const savedCols = localStorage.getItem('collection-cols');
      if (savedCols === '3') {
        setCols(3);
      } else {
        setCols(5); // Default to 5 columns
      }
    }

    // Load More (progressive enhancement over the real numbered pagination
    // above: the numbered links stay in the DOM as the no-JS/crawler
    // fallback, and are only visually replaced once JS confirms it can
    // drive the Section Rendering API fetch below).
    const loadMoreWrap = document.querySelector('[data-load-more]');
    if (loadMoreWrap) {
      const numberedPagination = document.querySelector('[data-numbered-pagination]');
      const grid = document.querySelector('[data-product-grid]');
      const countText = document.querySelector('.products-count-text');
      const totalCount = loadMoreWrap.getAttribute('data-total-count');
      const sectionId = loadMoreWrap.getAttribute('data-section-id');
      const btn = loadMoreWrap.querySelector('[data-load-more-btn]');
      const originalLabel = btn.textContent;

      loadMoreWrap.hidden = false;
      if (numberedPagination) numberedPagination.style.display = 'none';

      let nextUrl = loadMoreWrap.getAttribute('data-next-url');
      let loading = false;

      const updateCount = () => {
        if (!countText || !totalCount || !grid) return;
        const loaded = grid.querySelectorAll('.product-grid-item').length;
        countText.textContent = `Showing ${loaded} of ${totalCount} products`;
      };

      btn.addEventListener('click', async () => {
        if (loading || !nextUrl || !grid) return;
        const requestedUrl = nextUrl;
        loading = true;
        btn.disabled = true;
        btn.textContent = 'Loading…';

        try {
          const separator = requestedUrl.includes('?') ? '&' : '?';
          const response = await fetch(`${requestedUrl}${separator}section_id=${encodeURIComponent(sectionId)}`);
          if (!response.ok) throw new Error(`Request failed with ${response.status}`);
          const html = await response.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');

          const newItems = doc.querySelectorAll('[data-product-grid] .product-grid-item');
          newItems.forEach((item) => grid.appendChild(item));

          const nextWrap = doc.querySelector('[data-load-more]');
          nextUrl = nextWrap ? nextWrap.getAttribute('data-next-url') : null;
          loadMoreWrap.hidden = !nextUrl;
          if (nextUrl) loadMoreWrap.setAttribute('data-next-url', nextUrl);

          updateCount();
          history.pushState({}, '', requestedUrl);
        } catch (err) {
          console.error('Load more failed:', err);
        } finally {
          loading = false;
          btn.disabled = false;
          btn.textContent = originalLabel;
        }
      });

      // Clicking "Load More" pushes new history states without reloading;
      // going back through them should restore the real paginated page
      // rather than try to reconcile the grid back down.
      window.addEventListener('popstate', () => window.location.reload());
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const menuBtn = document.querySelector('.header-menu-btn');
    const drawer = document.querySelector('.header-menu-drawer');
    if (menuBtn && drawer) {
      menuBtn.addEventListener('click', () => {
        const isOpen = drawer.classList.toggle('is-open');
        menuBtn.setAttribute('aria-expanded', isOpen);
        const menuIcon = menuBtn.querySelector('img');
        if (menuIcon) {
          menuIcon.src = isOpen
            ? menuBtn.dataset.closeIcon
            : menuBtn.dataset.menuIcon;
        }
      });
    }

    document.querySelectorAll('.drawer-submenu-toggle').forEach((btn) => {
      btn.addEventListener('click', () => {
        const submenu = btn.closest('.drawer-nav-item').querySelector('.drawer-submenu');
        const isOpen = submenu.classList.toggle('is-open');
        btn.classList.toggle('is-open', isOpen);
        btn.setAttribute('aria-expanded', isOpen);
      });
    });

    document.querySelectorAll('[data-search-trigger]').forEach((searchTrigger) => {
      searchTrigger.addEventListener('click', (e) => {
        e.preventDefault();
        if (window.openSearchDrawer) window.openSearchDrawer();
      });
    });

    const cartTrigger = document.querySelector('[data-cart-drawer-trigger]');
    if (cartTrigger) {
      cartTrigger.addEventListener('click', (e) => {
        e.preventDefault();
        if (window.openCartDrawer) window.openCartDrawer();
        else window.location.href = '/cart';
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-brand-story"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.brand-story-image-wrapper').forEach(wrapper => {
      const slides = wrapper.querySelectorAll('.brand-story-slide');
      const dots = wrapper.querySelectorAll('.brand-story-dot');
      const prevBtn = wrapper.querySelector('.brand-story-prev');
      const nextBtn = wrapper.querySelector('.brand-story-next');

      if (slides.length <= 1) return;

      let current = 0;
      const show = (index) => {
        slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
        dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
        current = index;
      };

      if (prevBtn) {
        prevBtn.addEventListener('click', () => show((current - 1 + slides.length) % slides.length));
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', () => show((current + 1) % slides.length));
      }
      dots.forEach((dot, i) => dot.addEventListener('click', () => show(i)));
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-categories"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const categoriesSections = document.querySelectorAll('.categories-section');
    categoriesSections.forEach(section => {
      const track = section.querySelector('.cat-track');
      const prevBtn = section.querySelector('.cat-prev-btn');
      const nextBtn = section.querySelector('.cat-next-btn');
      
      if (!track) return;
      
      const scrollAmount = () => track.clientWidth * 0.8;
      
      if (prevBtn) {
        prevBtn.addEventListener('click', () => {
          track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
        });
      }
      
      if (nextBtn) {
        nextBtn.addEventListener('click', () => {
          track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-featured-products"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const featuredSections = document.querySelectorAll('.featured-products-section');
    featuredSections.forEach(section => {
      const track = section.querySelector('.feat-track');
      const prevBtn = section.querySelector('.feat-prev-btn');
      const nextBtn = section.querySelector('.feat-next-btn');
      
      if (!track) return;
      
      const scrollAmount = () => track.clientWidth * 0.8;
      
      if (prevBtn) {
        prevBtn.addEventListener('click', () => {
          track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
        });
      }
      
      if (nextBtn) {
        nextBtn.addEventListener('click', () => {
          track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
        });
      }

      // AJAX filtering: each product-type click fetches that type's best sellers
      // from the collection itself (Section Rendering API + native Shopify
      // product-type filter/sort), instead of hiding/showing pre-rendered tiles.
      const filterBtns = section.querySelectorAll('.feat-filter-btn');
      if (filterBtns.length === 0) return;

      const limit = parseInt(section.getAttribute('data-limit') || '8');
      const desktopColumns = parseInt(section.getAttribute('data-columns-desktop') || '4');
      const navContainer = section.querySelector('.categories-nav');
      const collectionUrl = section.getAttribute('data-collection-url');
      const sectionId = section.getAttribute('data-section-id');

      // Snapshot of the tiles as originally server-rendered, used to build
      // the initial "All" view without any extra request, and to resolve
      // each filter label to the exact backend product.type value (labels
      // may be typed as plurals, e.g. "Rings" vs. product.type "Ring").
      const initialTiles = Array.from(track.querySelectorAll('.feat-tile'));
      const initialAllHTML = initialTiles.slice(0, limit).map(tile => tile.outerHTML).join('');

      const normalize = (value) => (value || '').trim().toLowerCase();
      const fuzzyMatches = (tileType, filterLabel) => {
        const a = normalize(tileType);
        const b = normalize(filterLabel);
        return (
          a === b ||
          a + 's' === b ||
          a === b + 's' ||
          (a.endsWith('s') && a.slice(0, -1) === b) ||
          (b.endsWith('s') && b.slice(0, -1) === a)
        );
      };
      const resolveExactType = (filterLabel) => {
        for (const tile of initialTiles) {
          const tileType = tile.getAttribute('data-product-type');
          if (tileType && fuzzyMatches(tileType, filterLabel)) return tileType;
        }
        return filterLabel;
      };

      const updateNavVisibility = () => {
        if (!navContainer) return;
        const visibleTiles = track.querySelectorAll('.feat-tile').length;
        navContainer.style.display = visibleTiles > desktopColumns ? 'flex' : 'none';
      };

      const cache = new Map([['all', initialAllHTML]]);
      let requestToken = 0;

      const renderFilter = async (filterLabel) => {
        const token = ++requestToken;

        if (cache.has(filterLabel)) {
          track.innerHTML = cache.get(filterLabel);
          track.scrollLeft = 0;
          updateNavVisibility();
          track.style.opacity = '1';
          return;
        }

        if (!collectionUrl || !sectionId) {
          track.style.opacity = '1';
          return;
        }

        const exactType = resolveExactType(filterLabel);
        const url = `${collectionUrl}?section_id=${encodeURIComponent(sectionId)}&sort_by=best-selling&filter.p.product_type=${encodeURIComponent(exactType)}`;

        try {
          const response = await fetch(url);
          if (!response.ok) throw new Error(`Request failed with ${response.status}`);
          const html = await response.text();
          if (token !== requestToken) return; // a newer filter click superseded this request

          const doc = new DOMParser().parseFromString(html, 'text/html');
          const newTiles = Array.from(doc.querySelectorAll('.feat-track .feat-tile')).slice(0, limit);
          const markup = newTiles.map(tile => tile.outerHTML).join('');

          cache.set(filterLabel, markup);
          track.innerHTML = markup;
          track.scrollLeft = 0;
          updateNavVisibility();
        } catch (err) {
          console.error('Best sellers filter failed to load:', err);
        } finally {
          if (token === requestToken) track.style.opacity = '1';
        }
      };

      // Set initial state
      updateNavVisibility();

      filterBtns.forEach(btn => {
        btn.addEventListener('click', () => {
          if (btn.classList.contains('is-active')) return;

          filterBtns.forEach(b => b.classList.remove('is-active'));
          btn.classList.add('is-active');

          const filterType = btn.getAttribute('data-filter-type');

          track.style.transition = 'opacity 0.15s ease';
          track.style.opacity = '0.4';

          setTimeout(() => renderFilter(filterType), 150);
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const slideshows = document.querySelectorAll('.hero-slideshow');
    slideshows.forEach(slideshow => {
      const slides = slideshow.querySelectorAll('.hero-slide');
      const dots = slideshow.querySelectorAll('.hero-dot');
      const prevBtn = slideshow.querySelector('.hero-prev-btn');
      const nextBtn = slideshow.querySelector('.hero-next-btn');
      const counter = slideshow.querySelector('.hero-counter');
      
      if (slides.length === 0) return;
      
      let currentSlide = 0;
      
      const updateSlide = (index) => {
        slides[currentSlide].classList.remove('is-active');
        if (dots.length > 0) dots[currentSlide].classList.remove('is-active');
        
        currentSlide = (index + slides.length) % slides.length;
        
        slides[currentSlide].classList.add('is-active');
        if (dots.length > 0) dots[currentSlide].classList.add('is-active');
        
        if (counter) {
          counter.textContent = `${String(currentSlide + 1).padStart(2, '0')} / ${String(slides.length).padStart(2, '0')}`;
        }
      };
      
      if (prevBtn) prevBtn.addEventListener('click', () => updateSlide(currentSlide - 1));
      if (nextBtn) nextBtn.addEventListener('click', () => updateSlide(currentSlide + 1));
      
      dots.forEach((dot, idx) => {
        dot.addEventListener('click', () => updateSlide(idx));
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-vermeil-education"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const sections = document.querySelectorAll('.vermeil-education-section');
    sections.forEach(section => {
      const images = section.querySelectorAll('.vermeil-slide-img');
      const toneBtns = section.querySelectorAll('.vermeil-tone-btn');

      if (images.length === 0) return;

      let activeIdx = 0;

      const updateTone = (index) => {
        images[activeIdx].classList.remove('is-active');
        toneBtns[activeIdx].classList.remove('is-active');

        activeIdx = (index + images.length) % images.length;

        images[activeIdx].classList.add('is-active');
        toneBtns[activeIdx].classList.add('is-active');
      };

      toneBtns.forEach((btn, idx) => {
        btn.addEventListener('click', () => updateTone(idx));
      });
      
      // Swipe gestures on mobile
      const track = section.querySelector('.vermeil-slider-container');
      if (track) {
        let touchStartX = 0;
        track.addEventListener('touchstart', (e) => {
          touchStartX = e.touches[0].clientX;
        }, { passive: true });
        
        track.addEventListener('touchend', (e) => {
          const touchEndX = e.changedTouches[0].clientX;
          const diffX = touchEndX - touchStartX;
          if (Math.abs(diffX) > 40) {
            if (diffX < 0) {
              updateTone(activeIdx + 1);
            } else {
              updateTone(activeIdx - 1);
            }
          }
        }, { passive: true });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-login"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const loginForm = document.getElementById('CustomerLoginForm');
    const recoverForm = document.getElementById('RecoverPasswordForm');
    const showRecoverBtn = document.getElementById('RecoverPasswordBtn');
    const hideRecoverBtn = document.getElementById('HideRecoverPasswordBtn');

    if (showRecoverBtn && loginForm && recoverForm) {
      showRecoverBtn.addEventListener('click', (e) => {
        e.preventDefault();
        loginForm.style.display = 'none';
        recoverForm.style.display = 'flex';
      });
    }

    if (hideRecoverBtn && loginForm && recoverForm) {
      hideRecoverBtn.addEventListener('click', (e) => {
        e.preventDefault();
        recoverForm.style.display = 'none';
        loginForm.style.display = 'flex';
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    // Independent accordion state per category, single-open-at-a-time within a category
    document.querySelectorAll('.faq-category').forEach(category => {
      const items = category.querySelectorAll('.faq-item');
      
      items.forEach(item => {
        const header = item.querySelector('.faq-header');
        const icon = item.querySelector('.faq-icon');
        
        header.addEventListener('click', (e) => {
          e.preventDefault();
          const isOpen = item.classList.contains('is-open');
          
          // Close other items only inside THIS category
          items.forEach(otherItem => {
            otherItem.classList.remove('is-open');
            const otherIcon = otherItem.querySelector('.faq-icon');
            if (otherIcon) otherIcon.style.transform = 'none';
          });
          
          if (!isOpen) {
            item.classList.add('is-open');
            if (icon) icon.style.transform = 'rotate(180deg)';
          }
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    // 1. Variant Data Loading
    const variantScript = document.querySelector('#ProductVariantsJson');
    if (!variantScript) return;
    const variants = JSON.parse(variantScript.textContent);

    const variantIdInput = document.querySelector('#ProductVariantId');
    const skuLabel = document.querySelector('.pdp-sku');
    const comparePriceLabel = document.querySelector('.pdp-compare-price');
    const sellingPriceLabel = document.querySelector('.pdp-selling-price');
    const discountBadge = document.querySelector('.pdp-discount-badge');

    // State of selected options
    const selectedOptions = {};

    // 2. Filter images by finish value and lazy load active ones
    const filterGalleryByAlt = (altText) => {
      const desktopImages = document.querySelectorAll('.pdp-gallery-image-wrapper');
      const mobileSlides = document.querySelectorAll('.pdp-mobile-slide');
      const productTitle = (document.querySelector('.product-page-container')?.getAttribute('data-product-title') || '').toLowerCase().trim();
      const cleanAltText = altText.trim().toLowerCase();
      
      let matchCount = 0;
      desktopImages.forEach(item => {
        const itemAlt = (item.getAttribute('data-alt') || '').trim().toLowerCase();
        if (cleanAltText !== "" && itemAlt.includes(cleanAltText)) {
          matchCount++;
        }
      });

      const lazyLoadMedia = (item) => {
        // 1. Lazy load static images
        const img = item.querySelector('img[data-src]');
        if (img) {
          img.src = img.getAttribute('data-src');
          img.removeAttribute('data-src');
        }
        
        // 2. Lazy load video tags
        const video = item.querySelector('video[data-src]');
        if (video) {
          video.style.opacity = '0';
          video.style.transition = 'opacity 0.3s ease';
          
          const loader = item.querySelector('.pdp-media-loader');
          if (loader) {
            loader.classList.remove('is-hidden');
            loader.style.opacity = '1';
          }
          
          video.src = video.getAttribute('data-src');
          video.removeAttribute('data-src');
          video.muted = true;
          video.controls = false;
          video.removeAttribute('controls');
          video.load();
          
          const onVideoPlayable = () => {
            if (loader) {
              loader.classList.add('is-hidden');
              loader.style.opacity = '0';
            }
            video.style.opacity = '1';
            video.removeEventListener('canplay', onVideoPlayable);
          };
          
          if (video.readyState >= 3) {
            onVideoPlayable();
          } else {
            video.addEventListener('canplay', onVideoPlayable);
          }
          video.play().catch(err => console.log('Video play failed:', err));
        }
        
        // 3. Lazy load external videos (iframes)
        const extPlaceholder = item.querySelector('.pdp-external-video-lazy');
        if (extPlaceholder) {
          const loader = item.querySelector('.pdp-media-loader');
          if (loader) {
            loader.classList.remove('is-hidden');
            loader.style.opacity = '1';
          }
          
          const iframeSrc = extPlaceholder.getAttribute('data-src');
          if (iframeSrc) {
            const iframe = document.createElement('iframe');
            iframe.className = 'pdp-video';
            iframe.style.opacity = '0';
            iframe.style.transition = 'opacity 0.3s ease';
            iframe.src = iframeSrc;
            iframe.allow = 'autoplay; encrypted-media';
            iframe.allowFullscreen = true;
            iframe.style.width = '100%';
            iframe.style.height = '100%';
            iframe.style.border = 'none';
            
            iframe.addEventListener('load', () => {
              if (loader) {
                loader.classList.add('is-hidden');
                loader.style.opacity = '0';
              }
              iframe.style.opacity = '1';
            });
            
            extPlaceholder.replaceWith(iframe);
          }
        }
      };

      const filterItems = (items) => {
        items.forEach(item => {
          const itemAlt = (item.getAttribute('data-alt') || '').trim().toLowerCase();
          
          if (matchCount > 0) {
            // Show item if it contains the selected finish alt text, or is empty, or is the product title
            if ((cleanAltText !== "" && itemAlt.includes(cleanAltText)) || itemAlt === "" || itemAlt === productTitle) {
              item.style.display = 'block';
              lazyLoadMedia(item);
            } else {
              item.style.display = 'none';
            }
          } else {
            // If no items match, show only the global/product title images or empty alt ones
            if (itemAlt === "" || itemAlt === productTitle) {
              item.style.display = 'block';
              lazyLoadMedia(item);
            } else {
              item.style.display = 'none';
            }
          }
        });
      };

      filterItems(desktopImages);
      filterItems(mobileSlides);
      
      // Reset mobile slider index
      if (window.updateMobileSliderIndex) {
        window.updateMobileSliderIndex();
      }
    };

    // 3. Update variant pricing & availability display
    const updateVariantDisplay = (variant) => {
      if (!variant) return;

      variantIdInput.value = variant.id;
      if (skuLabel && variant.sku) skuLabel.textContent = variant.sku;
      
      // Formatting money (₹ format)
      const formatMoney = (cents) => {
        return '₹' + (cents / 100).toLocaleString('en-IN');
      };

      sellingPriceLabel.textContent = formatMoney(variant.price);
      
      if (variant.compare_at_price > variant.price) {
        comparePriceLabel.textContent = formatMoney(variant.compare_at_price);
        comparePriceLabel.classList.remove('hide');
        
        const diff = variant.compare_at_price - variant.price;
        const pct = Math.round((diff / variant.compare_at_price) * 100);
        discountBadge.textContent = `${pct}% Off`;
        discountBadge.classList.remove('hide');
      } else {
        comparePriceLabel.classList.add('hide');
        discountBadge.classList.add('hide');
      }

      // Check URL query parameters
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    };

    // 4. Variant search by options
    const updateVariant = () => {
      const match = variants.find(variant => {
        return variant.options.every((opt, idx) => {
          return selectedOptions[idx] === opt;
        });
      });

      if (match) {
        updateVariantDisplay(match);
      }
    };

    // Initialize option state
    document.querySelectorAll('.pdp-option-group').forEach(group => {
      const idx = group.getAttribute('data-option-index');
      const activeBtn = group.querySelector('.is-active');
      if (activeBtn) {
        selectedOptions[idx] = activeBtn.getAttribute('data-value');
      }

      // Swatch Click Listener
      group.addEventListener('click', (e) => {
        const btn = e.target.closest('button');
        if (!btn) return;
        e.preventDefault();
        
        group.querySelectorAll('button').forEach(b => b.classList.remove('is-active'));
        btn.classList.add('is-active');
        
        const val = btn.getAttribute('data-value');
        selectedOptions[idx] = val;
        
        // If finish changed, filter images
        if (group.classList.contains('finish-swatches-group')) {
          filterGalleryByAlt(val);
        }
        
        updateVariant();
      });
    });

    // Run initial image filter
    const initialFinishGroup = document.querySelector('.finish-swatches-group');
    if (initialFinishGroup) {
      const activeFinish = initialFinishGroup.querySelector('.is-active');
      if (activeFinish) {
        filterGalleryByAlt(activeFinish.getAttribute('data-value'));
      }
    }

    // 5. Desktop Magnifier Zoom
    document.querySelectorAll('.pdp-gallery-zoom').forEach(container => {
      const img = container.querySelector('img');
      if (!img) return;
      
      container.addEventListener('mouseenter', () => {
        img.style.transform = 'scale(1.9)';
      });
      container.addEventListener('mouseleave', () => {
        img.style.transform = 'scale(1)';
        img.style.transformOrigin = 'center center';
      });
      container.addEventListener('mousemove', (e) => {
        const rect = container.getBoundingClientRect();
        const x = ((e.clientX - rect.left) / rect.width) * 100;
        const y = ((e.clientY - rect.top) / rect.height) * 100;
        img.style.transformOrigin = `${x}% ${y}%`;
      });
    });

    // 6. Lightbox logic
    const lightbox = document.querySelector('#PdpLightbox');
    const lightboxImg = lightbox ? lightbox.querySelector('.pdp-lightbox-image-container') : null;
    const lightboxCounter = lightbox ? lightbox.querySelector('.pdp-lightbox-counter') : null;
    let lightboxIndex = 0;

    const getVisibleGalleryImages = () => {
      return Array.from(document.querySelectorAll('.pdp-gallery-image-wrapper')).filter(el => el.style.display !== 'none');
    };

    const openLightbox = (index) => {
      const visibleImages = getVisibleGalleryImages();
      if (visibleImages.length === 0 || !lightbox || !lightboxImg) return;
      
      lightboxIndex = (index + visibleImages.length) % visibleImages.length;
      const targetWrapper = visibleImages[lightboxIndex];
      const mediaType = targetWrapper.getAttribute('data-media-type');
      
      const imgContainer = lightbox.querySelector('.pdp-lightbox-image-container');
      if (imgContainer) {
        imgContainer.innerHTML = '';
        
        if (mediaType === 'video' || mediaType === 'external_video') {
          const targetVideo = targetWrapper.querySelector('video');
          if (targetVideo) {
            const videoClone = targetVideo.cloneNode(true);
            videoClone.controls = true; // Allow controls in lightbox
            videoClone.style.maxWidth = '100%';
            videoClone.style.maxHeight = '100%';
            videoClone.style.objectFit = 'contain';
            imgContainer.appendChild(videoClone);
          } else {
            const targetIframe = targetWrapper.querySelector('iframe');
            if (targetIframe) {
              const iframeClone = targetIframe.cloneNode(true);
              iframeClone.style.maxWidth = '100%';
              iframeClone.style.maxHeight = '100%';
              iframeClone.style.width = '100%';
              iframeClone.style.height = '100%';
              iframeClone.style.border = 'none';
              imgContainer.appendChild(iframeClone);
            }
          }
        } else {
          const targetImg = targetWrapper.querySelector('img');
          if (targetImg) {
            const newImg = document.createElement('img');
            newImg.className = 'pdp-lightbox-img';
            newImg.src = targetImg.src;
            newImg.alt = targetImg.alt;
            newImg.width = 560;
            newImg.height = 560;
            newImg.style.maxWidth = '100%';
            newImg.style.maxHeight = '100%';
            newImg.style.objectFit = 'contain';
            imgContainer.appendChild(newImg);
          }
        }
      }

      resetLightboxZoom();
      lightbox.style.display = 'flex';
      document.body.style.overflow = 'hidden';
      
      if (lightboxCounter) {
        lightboxCounter.textContent = `${lightboxIndex + 1} / ${visibleImages.length}`;
      }
    };

    const closeLightbox = () => {
      if (lightbox) lightbox.style.display = 'none';
      document.body.style.overflow = '';
    };

    if (lightbox) {
      lightbox.querySelector('.pdp-lightbox-close').addEventListener('click', closeLightbox);
      
      const navigateLightbox = (dir) => {
        openLightbox(lightboxIndex + dir);
      };
      
      lightbox.querySelector('.pdp-lightbox-prev').addEventListener('click', () => navigateLightbox(-1));
      lightbox.querySelector('.pdp-lightbox-next').addEventListener('click', () => navigateLightbox(1));
      
      // Swipe-to-navigate + pinch-to-zoom + pan (when zoomed) in lightbox
      const lightboxBody = lightbox.querySelector('.pdp-lightbox-body');
      const ZOOM_MIN = 1;
      const ZOOM_MAX = 4;
      let zoomScale = 1;
      let panX = 0;
      let panY = 0;
      let gestureStartDist = 0;
      let gestureStartScale = 1;
      let panPointerStart = { x: 0, y: 0 };
      let swipeStartX = 0;
      let isPinching = false;
      let isPanning = false;

      const touchDist = (touches) => Math.hypot(
        touches[0].clientX - touches[1].clientX,
        touches[0].clientY - touches[1].clientY
      );

      const applyLightboxTransform = (immediate) => {
        const img = lightbox.querySelector('.pdp-lightbox-img');
        if (!img) return;
        img.style.transition = immediate ? 'none' : 'transform 0.2s ease';
        img.style.transform = `translate(${panX}px, ${panY}px) scale(${zoomScale})`;
      };

      window.resetLightboxZoom = () => {
        zoomScale = 1;
        panX = 0;
        panY = 0;
        isPinching = false;
        isPanning = false;
        applyLightboxTransform(true);
      };

      lightboxBody.addEventListener('touchstart', (e) => {
        if (e.touches.length === 2) {
          isPinching = true;
          isPanning = false;
          gestureStartDist = touchDist(e.touches);
          gestureStartScale = zoomScale;
        } else if (e.touches.length === 1) {
          swipeStartX = e.touches[0].clientX;
          if (zoomScale > 1) {
            isPanning = true;
            panPointerStart = { x: e.touches[0].clientX - panX, y: e.touches[0].clientY - panY };
          }
        }
      }, { passive: true });

      lightboxBody.addEventListener('touchmove', (e) => {
        if (isPinching && e.touches.length === 2) {
          const dist = touchDist(e.touches);
          zoomScale = Math.min(ZOOM_MAX, Math.max(ZOOM_MIN, gestureStartScale * (dist / gestureStartDist)));
          applyLightboxTransform(true);
        } else if (isPanning && e.touches.length === 1) {
          panX = e.touches[0].clientX - panPointerStart.x;
          panY = e.touches[0].clientY - panPointerStart.y;
          applyLightboxTransform(true);
        }
      }, { passive: true });

      lightboxBody.addEventListener('touchend', (e) => {
        if (e.touches.length === 1) {
          // Released one finger of a pinch; continue as a pan if still zoomed in
          isPinching = false;
          if (zoomScale > 1) {
            isPanning = true;
            panPointerStart = { x: e.touches[0].clientX - panX, y: e.touches[0].clientY - panY };
          }
          return;
        }

        if (zoomScale <= 1) {
          window.resetLightboxZoom();
          if (!isPinching && !isPanning) {
            const diffX = e.changedTouches[0].clientX - swipeStartX;
            if (Math.abs(diffX) > 40) {
              navigateLightbox(diffX < 0 ? 1 : -1);
            }
          }
        }

        isPinching = false;
        isPanning = false;
      }, { passive: true });

      // Click on desktop gallery tiles to open lightbox
      document.querySelectorAll('.pdp-gallery-image-wrapper').forEach((el, index) => {
        el.addEventListener('click', () => {
          const visible = getVisibleGalleryImages();
          const visibleIdx = visible.indexOf(el);
          if (visibleIdx !== -1) {
            openLightbox(visibleIdx);
          }
        });
      });
    }

    // 7. Mobile Swipe Slider
    const initMobileSlider = () => {
      const slider = document.querySelector('.pdp-mobile-slider-track');
      const container = document.querySelector('.pdp-mobile-slider-container');
      const prevBtn = document.querySelector('.pdp-mobile-prev');
      const nextBtn = document.querySelector('.pdp-mobile-next');
      const counter = document.querySelector('.pdp-mobile-counter');
      
      if (!slider || !container) return;
      
      let currentIndex = 0;
      let startX = 0;
      let currentX = 0;
      let isDragging = false;
      let moved = false;
      
      const getVisibleSlides = () => {
        return Array.from(container.querySelectorAll('.pdp-mobile-slide')).filter(el => el.style.display !== 'none');
      };
      
      const updateSlide = (idx) => {
        const slides = getVisibleSlides();
        if (slides.length === 0) return;
        
        currentIndex = (idx + slides.length) % slides.length;
        
        slider.style.transition = 'transform 0.35s cubic-bezier(.22,.61,.36,1)';
        slider.style.transform = `translateX(-${currentIndex * 100}%)`;
        
        if (counter) {
          counter.textContent = `${currentIndex + 1} / ${slides.length}`;
        }
      };
      
      container.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
        isDragging = true;
        moved = false;
        slider.style.transition = 'none';
      }, { passive: true });
      
      container.addEventListener('touchmove', (e) => {
        if (!isDragging) return;
        currentX = e.touches[0].clientX;
        const deltaX = currentX - startX;
        
        if (Math.abs(deltaX) > 5) {
          moved = true;
        }
        
        const baseOffset = -currentIndex * container.clientWidth;
        slider.style.transform = `translateX(${baseOffset + deltaX}px)`;
      }, { passive: true });
      
      container.addEventListener('touchend', () => {
        if (!isDragging) return;
        isDragging = false;
        
        const deltaX = currentX - startX;
        if (moved && Math.abs(deltaX) > 60) {
          if (deltaX < 0) {
            updateSlide(currentIndex + 1);
          } else {
            updateSlide(currentIndex - 1);
          }
        } else {
          updateSlide(currentIndex);
        }
        
        if (!moved) {
          openLightbox(currentIndex);
        }
      });
      
      if (prevBtn) prevBtn.addEventListener('click', () => updateSlide(currentIndex - 1));
      if (nextBtn) nextBtn.addEventListener('click', () => updateSlide(currentIndex + 1));
      
      window.updateMobileSliderIndex = () => updateSlide(0);
    };

    initMobileSlider();

    // 8. Size Guide Modal open/close
    const sizeGuide = document.querySelector('#SizeGuideModal');
    const openGuideBtns = document.querySelectorAll('[data-open-size-guide]');
    const closeGuideBtns = document.querySelectorAll('[data-close-size-guide]');
    
    if (sizeGuide) {
      openGuideBtns.forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          sizeGuide.style.display = 'flex';
          document.body.style.overflow = 'hidden';
        });
      });
      
      closeGuideBtns.forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          sizeGuide.style.display = 'none';
          document.body.style.overflow = '';
        });
      });
    }



    // 10. Share tooltip - there are two share buttons (desktop title row, mobile
    // image overlay), so bind every instance rather than just the first match.
    document.querySelectorAll('.pdp-share-btn').forEach((shareBtn) => {
      const tooltip = shareBtn.querySelector('.share-tooltip');
      shareBtn.addEventListener('click', async (e) => {
        e.preventDefault();
        const shareData = {
          title: document.title,
          text: `Check out ${document.querySelector('.pdp-title')?.textContent.trim() || ''} on Contempry`,
          url: window.location.href
        };
        if (navigator.share) {
          try {
            await navigator.share(shareData);
            return;
          } catch (err) {}
        }
        try {
          await navigator.clipboard.writeText(shareData.url);
          if (tooltip) {
            tooltip.classList.add('is-visible');
            setTimeout(() => {
              tooltip.classList.remove('is-visible');
            }, 1800);
          }
        } catch (err) {}
      });
    });

    // 11. Pincode availability check
    const pincodeBtn = document.querySelector('#PincodeCheckBtn');
    const pincodeInput = document.querySelector('#PincodeInput');
    const pincodeMsg = document.querySelector('#PincodeMessage');

    if (pincodeBtn && pincodeInput && pincodeMsg) {
      pincodeInput.addEventListener('input', () => {
        pincodeInput.value = pincodeInput.value.replace(/\D/g, '').slice(0, 6);
        pincodeMsg.innerHTML = '';
      });
      
      pincodeBtn.addEventListener('click', () => {
        const val = pincodeInput.value;
        if (val.length !== 6) return;
        
        const isAvailable = Number(val[val.length - 1]) % 2 === 0;
        if (isAvailable) {
          pincodeMsg.innerHTML = `
            <div class="pincode-status success">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="var(--accent-coral)" stroke-width="2.5"><polyline points="20 6 9 17 4 12"></polyline></svg>
              <span>Free shipping available. Expected delivery within 10–15 days.</span>
            </div>
          `;
        } else {
          pincodeMsg.innerHTML = `
            <div class="pincode-status error">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="var(--accent-coral)" stroke-width="2.5"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
              <span>Delivery is currently unavailable for this location.</span>
            </div>
          `;
        }
      });
    }

    // 12. Accordions open/close
    document.querySelectorAll('.accordion-header').forEach(header => {
      header.addEventListener('click', () => {
        const parent = header.parentElement;
        const icon = header.querySelector('.accordion-icon');
        const isOpen = parent.classList.contains('is-open');
        
        // Close other accordions
        document.querySelectorAll('.accordion-item').forEach(item => {
          item.classList.remove('is-open');
          const itemIcon = item.querySelector('.accordion-icon');
          if (itemIcon) itemIcon.style.transform = 'none';
        });
        
        if (!isOpen) {
          parent.classList.add('is-open');
          if (icon) icon.style.transform = 'rotate(180deg)';
        }
      });
    });

    // 13. Mobile Sticky CTA observer
    const stickyBar = document.querySelector('.pdp-sticky-cta');
    const ctasWrapper = document.querySelector('.pdp-ctas-wrapper');
    if (stickyBar && ctasWrapper && 'IntersectionObserver' in window) {
      // Show the bar only once the real Add to Bag / Buy Now buttons have scrolled
      // up out of view (their bottom edge is above the viewport). Not-intersecting
      // alone is not enough: the buttons are also off-screen *below* the fold on
      // page load, and the bar must stay hidden then so finish options stay visible.
      const observer = new IntersectionObserver(([entry]) => {
        const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
        stickyBar.classList.toggle('is-visible', scrolledPast);
      }, { threshold: 0 });
      observer.observe(ctasWrapper);
      
      // Wire mobile sticky buttons to submit main form
      const productForm = document.querySelector('#ProductForm');
      if (productForm) {
        stickyBar.querySelector('.pdp-sticky-add-to-bag').addEventListener('click', () => {
          productForm.querySelector('.buy-box-add-to-bag').click();
        });
        stickyBar.querySelector('.pdp-sticky-buy-now').addEventListener('click', () => {
          productForm.querySelector('.buy-box-buy-now').click();
        });
      }
    }

    // 14. Related Products scroll-snap navigation
    const relatedTrack = document.querySelector('.related-track');
    const relatedPrev = document.querySelector('.related-prev');
    const relatedNext = document.querySelector('.related-next');
    if (relatedTrack) {
      const scrollAmount = () => relatedTrack.clientWidth / 3.2;
      if (relatedPrev) {
        relatedPrev.addEventListener('click', () => {
          relatedTrack.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
        });
      }
      if (relatedNext) {
        relatedNext.addEventListener('click', () => {
          relatedTrack.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
        });
      }
    }

    // Buy Now button intercepts
    const buyNowBtn = document.querySelector('[data-buy-now]');
    if (buyNowBtn) {
      buyNowBtn.addEventListener('click', (e) => {
        e.preventDefault();
        // Add variant to cart and redirect directly to checkout
        const variantId = variantIdInput.value;
        const data = {
          items: [{ id: parseInt(variantId), quantity: 1 }]
        };
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(data)
        })
        .then(() => {
          window.location.href = '/checkout';
        })
        .catch(() => {
          window.location.href = '/checkout';
        });
      });
    }

    // "Add to Bag" - intercept the form submit (Buy Now above already prevents
    // its own click from ever reaching here) so this adds via AJAX and opens the
    // cart drawer in place, instead of a full-page redirect to /cart.
    const productForm = document.getElementById('ProductForm');
    const addToCartError = document.getElementById('PdpAddToCartError');
    if (productForm) {
      productForm.addEventListener('submit', (e) => {
        e.preventDefault();

        const addBtn = productForm.querySelector('.buy-box-add-to-bag');
        if (addBtn) addBtn.disabled = true;
        if (addToCartError) {
          addToCartError.hidden = true;
          addToCartError.textContent = '';
        }

        fetch('/cart/add.js', {
          method: 'POST',
          body: new FormData(productForm)
        })
          .then(async (res) => {
            const data = await res.json();
            if (!res.ok) throw new Error(data.description || data.message || 'Could not add this item to your bag.');

            if (window.refreshCartDrawer && window.openCartDrawer) {
              window.refreshCartDrawer().then(window.openCartDrawer);
            } else {
              const cartUrlInput = document.getElementById('ProductCartUrl');
              window.location.href = cartUrlInput ? cartUrlInput.value : '/cart';
            }
          })
          .catch((err) => {
            console.error('Add to cart error:', err);
            if (addToCartError) {
              addToCartError.textContent = err.message || 'Could not add this item to your bag.';
              addToCartError.hidden = false;
            }
          })
          .finally(() => {
            if (addBtn) addBtn.disabled = false;
          });
      });
    }

    // IJC certificate lightbox
    const certLightbox = document.getElementById('IjcCertLightbox');
    const certLightboxOpenBtn = document.querySelector('[data-cert-lightbox-open]');
    if (certLightbox && certLightboxOpenBtn) {
      const openCertLightbox = () => {
        certLightbox.hidden = false;
        document.body.style.overflow = 'hidden';
      };
      const closeCertLightbox = () => {
        certLightbox.hidden = true;
        document.body.style.overflow = '';
      };
      certLightboxOpenBtn.addEventListener('click', openCertLightbox);
      certLightbox.querySelectorAll('[data-cert-lightbox-close]').forEach((el) => {
        el.addEventListener('click', closeCertLightbox);
      });
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && !certLightbox.hidden) closeCertLightbox();
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
